import { Form, Input } from 'antd';
import getMessage from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';

export const NicknameFormItem = () => {
    return (
        <section style={{ width: '100%' }}>
            <div style={{ marginBottom: 16 }} className="label">
                ニックネーム
            </div>
            <Form.Item
                required={false}
                className="input-font-style label-form-style "
                name="nickName"
                label={false}
                rules={[
                    {
                        required: true,
                        message: getMessage('In_Required', 'ニックネーム'),
                    },
                ]}
            >
                <Input
                    style={{ width: '100%' }}
                    placeholder={PLACEHOLDER.NICKNAME}
                    maxLength={20}
                    autoComplete="off"
                />
            </Form.Item>
        </section>
    );
};
